import React, {useState} from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import {makeStyles} from "@material-ui/core";
import {StyledTextArea, StyledSelect} from "../Typeset"

const useStyles = makeStyles({
  root: {
    backgroundColor: 'rgb(84, 86, 95)',
    color: 'white'
  },
  buttonRow: {
    backgroundColor: 'rgb(84, 86, 95)',
    color: 'white',
    padding: 24,
  },
  textWhite: {
    color: 'white',
    fontSize: 14
  },
  buttonStyleFilled: {
    background: '#F62459',
    color: '#FFF',
    padding: '8px 20px',
    '&:hover': {
      background: '#C93756'
    },
  },
});

export default function FormDialog({
  isOpen, handleClose, handleSubmit, firstName, lastName, ticketTier, eventTitle, hash, referenceId
}) {
  const classes = useStyles();
  const [reason, setReason] = useState('')
  const [reasonOther, setReasonOther] = useState('')
  const [acknowledgeTerms, setAcknowledgeTerms] = useState(false)


  return (
    <Dialog open={isOpen} onClose={handleClose} aria-labelledby="form-dialog-title">
      <DialogTitle className={classes.root} id="form-dialog-title">REQUEST A REFUND</DialogTitle>
      <DialogContent className={classes.root}>
        <DialogContentText className={classes.textWhite}>
          If you would like to request a refund for this
          ticket please click the request refund button below.
          <br /><br />
          Event: <b>{eventTitle}</b><br />
          Ticket Tier: <b>{ticketTier}</b> <br />
          Name on Ticket:  <b>{firstName} {lastName}</b> <br />
          Barcode: <b>{hash} - {referenceId}</b>
          <br /><br />
          Your ticket will remain valid until the refund is processed.
          If the ticket is scanned, name changed or resold in the meantime
          then the refund will be denied.
        </DialogContentText>

        <div style={{fontSize: '0.8rem', marginBottom: 6}}>Reason</div>
        <StyledSelect value={reason} onChange={(evt) => setReason(evt.target.value)}>
          <option value={''}>
          </option>
          <option>
            I can no longer attend the event date
          </option>
          <option>
            I am unwell, sick or injured
          </option>
          <option>
            I accidentally purchased duplicate tickets
          </option>
          <option>
            I no longer wish to attend
          </option>
          <option>
            Other (Please specify)
          </option>
        </StyledSelect>

        {reason === 'Other (Please specify)' &&
        <>
          <div style={{fontSize: '0.8rem', marginBottom: 6}}>Other (Please specify)</div>
          <div style={{marginBottom: 6}}>
            <StyledTextArea
              autoFocus
              type="text"
              fullWidth
              maxlength="250"
              value={reasonOther}
              onChange={(evt) => setReasonOther(evt.target.value)}
            />
            <div style={{
              textAlign: 'right',
              fontSize: 14,
              marginTop: -10
            }}>{reasonOther.length} / 250</div>
          </div>
        </>}
        <div style={{display: 'flex', alignItems: 'center', marginBottom: 6}}>
          <input
            type="checkbox"
            id="acknowledgement"
            checked={acknowledgeTerms}
            onChange={() => setAcknowledgeTerms(!acknowledgeTerms)}
          />
          <label htmlFor="acknowledgement" style={{fontSize: '0.8rem', marginLeft: 10}}>
            I agree with the <a style={{color: 'white'}} href="https://triniq.com/terms" target="_blank">
              terms & conditions of sale
            </a>.
          </label>
        </div>
      </DialogContent>
      <DialogActions className={classes.buttonRow}>
        <Button className={classes.textWhite} onClick={handleClose} color="primary">
          Cancel
        </Button>
        <Button
          disabled={!reason || (reason === 'Other (Please specify)' && !reasonOther) || !acknowledgeTerms}
          onClick={() => handleSubmit({
            other_please_specify: reasonOther,
            reason: reason,
          })}
          color="primary"
          className={classes.buttonStyleFilled}
        >
          Request Refund
        </Button>
      </DialogActions>
    </Dialog>
  );
}
